import styled from '@emotion/styled'
import { Locale, Translation } from 'locale'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { showDraftMappingSelector } from 'selectors/globalGridSelectors'
import { canEditSectorMappingSelector, canViewOrEditSectorMappingSelector } from 'selectors/productSelectors'
import { GridActions } from 'store/grid'
import { getTextFlagButtonState, TextFlagButtonsContainer, ToolbarTextFlagButton } from 'view/components/buttons'
import { ToolbarToggleWrapper } from 'view/components/datagrid/toolbar/toolbarStyles'

export const SectorMappingDraftButtonWrapper = styled.div`
  margin-left: auto;
`

export const SectorMappingDraftButton: React.FC = () => {
  const canEditSectorMapping = useSelector(canEditSectorMappingSelector)
  const canViewOrEditSectorMapping = useSelector(canViewOrEditSectorMappingSelector)
  const draftView = useSelector(showDraftMappingSelector)

  const dispatch = useDispatch()
  return (
    <SectorMappingDraftButtonWrapper>
      <ToolbarToggleWrapper>
        <TextFlagButtonsContainer>
          {canViewOrEditSectorMapping && (
            <ToolbarTextFlagButton
              dataTestId={'AdvancedDealSubscriptionFilters-ToolbarTextFlagButton-ButtonToday'}
              state={getTextFlagButtonState(!draftView)}
              onClick={() => dispatch(GridActions.saveGlobalGridSettings({ showDraftMapping: false }))}>
              {Locale.translate(Translation.TC_SECTOR_CURRENT_MAPPINGS)}
            </ToolbarTextFlagButton>
          )}

          {canEditSectorMapping && (
            <ToolbarTextFlagButton
              dataTestId={'AdvancedDealSubscriptionFilters-ToolbarTextFlagButton-SearchButton'}
              state={getTextFlagButtonState(draftView)}
              onClick={() => dispatch(GridActions.saveGlobalGridSettings({ showDraftMapping: true }))}>
              {Locale.translate(Translation.TC_SECTOR_DRAFT_MAPPINGS)}
            </ToolbarTextFlagButton>
          )}
        </TextFlagButtonsContainer>
      </ToolbarToggleWrapper>
    </SectorMappingDraftButtonWrapper>
  )
}
